"use strict";
exports.__esModule = true;
exports.isEmpty = void 0;
var isEmpty = function (obj) {
    // eslint-disable-next-line guard-for-in
    for (var _1 in obj) {
        return false;
    }
    return true;
};
exports.isEmpty = isEmpty;
